module.exports = __webpack_public_path__ + "static/media/default.0e082c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/easyToBreak/index/default.png
// module id = 1212
// module chunks = 0